import { RefConfig, refConfigArray } from "../../data/ref/refConfig";

export const sanitizeString = (ref: string | undefined): string | undefined => {
  if (!ref) return undefined;

  const sanitizedRef = ref.replace(/[^a-zA-Z0-9_-]/g, "").toLowerCase();
  return sanitizedRef || undefined;
}

export const getRefValue = (ref: string | string[] | undefined): string | undefined => {
  return Array.isArray(ref) ? sanitizeString(ref[0]) : sanitizeString(ref);
}

export const getRefConfig = (ref: string | string[] | undefined): RefConfig | undefined => {
  const refValue = getRefValue(ref);
  if (!refValue) return undefined;

  return refConfigArray.find(
    (config) => config.ref.toLowerCase() === refValue.toLowerCase()
  );
}
